import React from 'react';

import type IconBuilder from '~/components/patterns/icons/builders/iconsData/IconBuilder';



const PerplexityIconBuilder: IconBuilder = {
	icon: () => {
		return (
			<path
				clip-rule="evenodd"
				d="m37.008 0 89.982 82.905V.191h17.516v83.085L234.891 0v94.524H272v136.342h-36.995v84.169l-90.499-79.51v80.423H126.99v-79.112L37.11 316v-85.134H0V94.524h37.008V0Zm76.777 111.826h-96.27v101.738h19.573v-32.092l76.697-69.646Zm-59.16 77.323v88.243l72.365-63.737v-90.234l-72.365 65.728Zm90.385 23.663v-89.476l72.386 65.732v41.798h.093v45.625l-72.479-63.679Zm89.995.752h19.479V111.826h-95.552l76.073 68.925v32.813Zm-17.63-119.04V39.798l-59.398 54.726h59.398Zm-103.454 0H54.524V39.798l59.397 54.726Z"
				fill="#21808d"
				fill-rule="evenodd"
			/>
		);
	},
	viewBoxHeight: 316,
	viewBoxWidth: 272,
};



export default PerplexityIconBuilder;

